import { IRequestFilters } from './components/PCFilter/typings';
import cloneDeep from 'lodash/cloneDeep';
import { ObjectKeys } from '@/utils/tsUtils';
import { useState, useEffect } from 'react';

/** 对filter的数据进行格式清洗 */
export function filterFormatter(filters: IRequestFilters) {
  // 深拷贝一份，避免副作用
  const clonedTarget = cloneDeep(filters);

  ObjectKeys(clonedTarget).forEach((key) => {
    // 去除掉长度为0 或 undefined的filter
    if ((clonedTarget[key] && clonedTarget[key].length === 0) || !clonedTarget[key]) {
      delete clonedTarget[key];
    }
  });

  return clonedTarget;
}

/** 跳转搜索结果页 */
export const redirectToSearchResultsPage = (params: Record<string, string> = {}) => {
  const query = new URLSearchParams(params).toString();
  window.location.href = `/search-results${query ? '?' + query : ''}`;
};

// 带state的搜索结果页，可用于ssr
export const useSearchPage = () => {
  const [isSearchResultsPage, setIsSearchResultsPage] = useState(false);

  useEffect(() => {
    setIsSearchResultsPage(checkIsSearchResultsPage());
  }, []);

  return {
    isSearchResultsPage,
  };
};

// 判断是否为搜索结果页面
export const checkIsSearchResultsPage = () => {
  if (typeof window === 'undefined') return false;

  return window?.location?.pathname === '/search-results';
};
